const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconTotaltransactions(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 55,
    viewBox: "0 0 55 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Icon\\\\\\\\total transactions",
    style: {
      opacity: 0.6
    }
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17684"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17683"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 51022",
    d: "M134.111 138.694c1.247-.4 2.148-1.244 2.148-2.166s-.9-1.763-2.148-2.166zm-1.611-23.919a17.725 17.725 0 1 0 17.725 17.725 17.745 17.745 0 0 0-17.725-17.725zm4.765 17.615a4.969 4.969 0 0 1 0 8.275 7.6 7.6 0 0 1-3.153 1.353v.149a1.611 1.611 0 1 1-3.223 0v-.149a7.593 7.593 0 0 1-3.153-1.353 5.218 5.218 0 0 1-2.218-4.138 1.611 1.611 0 1 1 3.223 0c0 .922.9 1.763 2.148 2.166v-4.732a7.593 7.593 0 0 1-3.153-1.353 4.969 4.969 0 0 1 0-8.275 7.6 7.6 0 0 1 3.153-1.353v-.149a1.611 1.611 0 1 1 3.223 0v.149a7.593 7.593 0 0 1 3.153 1.353 5.218 5.218 0 0 1 2.218 4.138 1.611 1.611 0 1 1-3.223 0c0-.922-.9-1.763-2.148-2.166v4.732a7.6 7.6 0 0 1 3.153 1.354zm-8.525-3.919c0 .922.9 1.763 2.148 2.166v-4.332c-1.247.404-2.148 1.245-2.148 2.167zm29.984-4.151a1.611 1.611 0 1 0-3.072.974 24.182 24.182 0 0 1-36.871 27.146 1.611 1.611 0 0 0 .664-3.132l-6.836-2.279a1.611 1.611 0 0 0-2.038 2.038l2.279 6.836a1.611 1.611 0 0 0 3.057-1.019l-.251-.754a27.407 27.407 0 0 0 43.069-29.812zm-50.5 8.072a24.179 24.179 0 0 1 38-19.833 1.611 1.611 0 0 0-.664 3.132l6.836 2.279a1.611 1.611 0 0 0 2.038-2.038l-2.279-6.836a1.611 1.611 0 1 0-3.057 1.019l.251.754a27.407 27.407 0 0 0-43.069 29.811 1.611 1.611 0 0 0 3.072-.974 24.167 24.167 0 0 1-1.129-7.313z",
    transform: "translate(-105 -105)",
    style: {
      fill: "#fff"
    }
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTotaltransactions);
export default __webpack_public_path__ + "static/media/Icon_total transactions.b3b8bdc942ac292dc11a55623d5b2a9f.svg";
export { ForwardRef as ReactComponent };